export const getButtonLoadingStyles = (isLoading?: boolean) => ({
    // fade in content after done loading data
    transition: "opacity 0.3s",
    opacity: isLoading ? 0 : 1,
});
